export const BLANK_PAYLOAD = {
  identifiers: [],
  code: { display: '', code: '' },
  description: '',
  priority: '',
  forRef: '',
  basedOnRefs: [],
  focusRef: '',
  reason: null,
  note: '',
  partofRef: '',
  startDate: '',
  endDate: '',
  ownerRef: { display: '', reference: '' },
  restriction: null,
  referralId: '',
};

/**
 * Task code → the label the Add Task form shows for it.
 *
 * Read with a runtime-chosen code from the category dropdown, so the key set is open
 * and a code with no entry must read as `undefined` rather than TS7053. Same
 * intersection idiom as the template maps in `fhir-sdoh/common/constants`: a fixed
 * literal key still resolves through the literal member and stays `string`.
 */
const CODE_DISPLAYS_LITERAL = {
  survey: 'Conduct a Questionnaire',
  'food-delivery': 'Meal Delivery',
  'food-card': 'Food Card Delivery',
  consultation: 'Consultation',
  education: 'Send Educational Material',
  touchpoint: 'Member Touchpoint',
  communication: 'Member Engagement',
  care: 'Care Management task',
  'food-box': 'Food Box',
  'food-recall': 'Food Recall',
  triage: 'Triage',
  outreach: 'Outreach',
  'other-goods-delivery': 'Other Goods Delivery',
};

export const CODE_DISPLAYS: typeof CODE_DISPLAYS_LITERAL & Record<string, string | undefined> =
  CODE_DISPLAYS_LITERAL;

export const PRIORITY_CATEGORIES = ['routine', 'asap'];

export const PRIORITY_MAP = { routine: 'STANDARD', asap: 'HIGH PRIORITY' };

export const TASK_CATEGORIES = [
  'touchpoint',
  'survey',
  'food-card',
  'food-box',
  'food-delivery',
  'other-goods-delivery',
  'food-recall',
  'education',
  'consultation',
  'careplan',
  'communication',
  'triage',
  'outreach',
  'enrollment-action',
];
